// extracted by mini-css-extract-plugin
module.exports = {"root":"SportButton_root__NPO9f","withoutTextShadow":"SportButton_withoutTextShadow__szh_T"};